import { computed } from 'vue';

import { useLicenseStore } from '@/stores/licenseStore';
import { useSessionStore } from '@/stores/session';

import MainSettingsPage from '@/components/settings/MainSettingsPage.vue';
import SubNetworksSettingsPage from '@/components/settings/SubNetworksSettingsPage.vue';
import NearSettingsPage from '@/components/settings/NearSettingsPage.vue';
import ProfileManagementForm from '@/components/settings/profiles/ProfileManagementForm.vue';
import ExternalSourcesPage from '@/components/settings/ExternalSourcesPage.vue';
import FTPNavigatorPage from '@/components/settings/FTPNavigatorPage.vue';
import EmailAlertsSettingsPage from '@/components/settings/EmailAlertsSettingsPage.vue';
import BrdcmSettingsPage from '@/components/settings/BrdcmSettingsPage.vue';
import AboutPage from '@/components/settings/AboutPage.vue';
import MetricsPage from '@/components/settings/MetricsPage.vue';
import DatabaseIndexesPage from '@/components/settings/DatabaseIndexesPage.vue';

const SETTINGS_BASE_ROUTES = [
	{ value: 'main', component: MainSettingsPage },
	{ value: 'sub-networks', component: SubNetworksSettingsPage },
	{ value: 'near', component: NearSettingsPage },
	{ value: 'profile-management', component: ProfileManagementForm },
	{ value: 'external-sources', component: ExternalSourcesPage },
	{ value: 'ftp-navigator', component: FTPNavigatorPage },
	{ value: 'email-alerts', component: EmailAlertsSettingsPage },
	{ value: 'brdcm', component: BrdcmSettingsPage },
	{ value: 'about', component: AboutPage },
];

const SETTINGS_DEBUG_ROUTES = [
	{ value: 'metrics', component: MetricsPage },
	{ value: 'database-indexes', component: DatabaseIndexesPage },
];

export const useSettingsRoutes = () => {
	const sessionStore = useSessionStore();
	const licenseStore = useLicenseStore();
	return computed(() => {
		let routes = SETTINGS_BASE_ROUTES.filter(route => (
			route.value !== 'brdcm' || licenseStore.allowBrdcm
		));
		if (sessionStore.debug) {
			routes.push(...SETTINGS_DEBUG_ROUTES);
		}
		return routes;
	});
};
